import React from 'react'
export default class ChildCampaignModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {}        
  }

  render() {
    return (
      <>
        {this.props.isChildCampaignModalOpen && (
          <div className="campaignChildModal modal is-active">
            <div className="modal-content">
              <article className="message">
                <div className="message-header">
                  <span>Update the child campaign</span>
                </div>
                <div className="message-body">
                  {this.props.editChildCampaign && <div style={{ display: "flex" }}>
                    <div className="input-container">
                      <label htmlFor="campaignStartDate">Campaign/Flight start date</label>
                      <input type="date" id="start-date" name="childCampaignStartDate" className="input start-date-input"
                        value={this.props.childCampaignStartDate}
                        onChange={this.props.handleChildCampaignDates}
                        data-date={this.props.getDate(this.props.childCampaignStartDate) || "Enter Start Date"}
                        min={this.props.parentCampaign['startDate']}
                        max={this.props.parentCampaign['endDate']} />
                    </div>
                    <div className="input-container">
                      <label htmlFor="campaignEndDate">Campaign/Flight end date</label>
                      <input type="date" id="end-date" name="childCampaignEndDate" className="input end-date-input"
                        value={this.props.childCampaignEndDate}
                        onChange={this.props.handleChildCampaignDates}
                        data-date={this.props.getDate(this.props.childCampaignEndDate) || "Enter End Date"}
                        min={this.props.childCampaignStartDate || this.props.parentCampaign['startDate']}
                        max={this.props.parentCampaign['endDate']} />
                    </div>
                  </div>}
                  {this.props.editChildCampaign ? this.props.getParentCampaignMediaMixAccordion() : this.props.getMediaMixAccordion(true)}
                </div>
                <div className="message-footer">

                  {this.props.displayChildCampaignTotalErrorMessage ?
                    <span className="error-message">Selected channels total is more than parent campaign total</span> :
                    <span>*  Selected channels total net media should be less than or equal to parent campaign net media</span>
                  }
                  <div className='button-container'>
                    <button className='button is-text is-medium' onClick={this.props.onModalClose}>Cancel</button>
                    {this.props.editChildCampaign ?
                      <button className='tertiary medium' onClick={this.props.saveChildCampaignChanges} disabled={!this.props?.enableSelectChannelButton}>Save</button>
                      :
                      <button className='medium' onClick={this.props.createChildCampaignPreview} disabled={!this.props?.enableSelectChannelButton}>Select</button>
                    }
                  </div>
                </div>
              </article>
            </div>
          </div>
        )}
      </>
    );
  }
}